import { render, staticRenderFns } from "./FilterSearchbar.vue?vue&type=template&id=6b046420&scoped=true&"
import script from "./FilterSearchbar.vue?vue&type=script&lang=js&"
export * from "./FilterSearchbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b046420",
  null
  
)

export default component.exports